/* eslint-disable react/prop-types */
/*
Author: Gilang Romadhanu Tartila
*/

import * as React from 'react';
import { useDispatch } from 'react-redux';
import {
  createStackNavigator,
  CardStyleInterpolators,
} from '@react-navigation/stack';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { isWeb } from '@global/screens';
import { setTitleHeader, setDefaultStackOption } from '@global/helpers';
import { showPopup } from '@/store/modal';

import HamburgerButton from '@components/navbar/HamburgerButton';
import NotificationSettingButton from '@components/navbar/NotificationSettingButton';
import MoreButton from '@components/navbar/MoreButton';

import CalendarScreen from '@/screens/calendar/CalendarScreen';

const Stack = createStackNavigator();

const CalendarNavigator = ({ navigation }) => {
  const insets = useSafeAreaInsets();
  const dispatch = useDispatch();

  return (
    <Stack.Navigator
      initialRouteName="CalendarScreen"
      screenOptions={(props) => ({
        headerLeft: () => <HamburgerButton {...props} />,
        headerRight: false,
        ...setDefaultStackOption(insets, CardStyleInterpolators),
      })}>
      <Stack.Screen
        name="CalendarScreen"
        component={CalendarScreen}
        options={(props) => {
          const title = 'Calendar';
          const showFilter = () => {
            dispatch(showPopup({ name: 'showFilter', value: 'calender' }));
          };
          const showExport = () => {
            dispatch(
              showPopup({ name: 'exportCalenderActivity', value: true }),
            );
          };

          const menus = [
            {
              type: 'function',
              name: 'Export',
              callback: showExport,
            },
            { type: 'function', name: 'Filter', callback: showFilter },
          ];
          return {
            title: setTitleHeader(title),
            headerRight: () =>
              isWeb ? (
                <NotificationSettingButton {...props} />
              ) : (
                <MoreButton menu={menus} {...props} />
              ),
          };
        }}
      />
    </Stack.Navigator>
  );
};

export default CalendarNavigator;
